import * as React from "react";
import { observer } from "mobx-react-lite";
import { Checkbox, Table } from "antd";
import { isChecked } from "src/common/groupChecked";
import { ResizerStd } from "src/pages/EntityFiltersPage/AsyncTableView/ResizerStd";
import { ColumnPoor } from "src/components/tables/ColumnPoor";
import { classNames } from "src/common/classNames";
import { Planning2ControlData } from "../Planning2ControlStore";
import { ZPlanning2Row } from "../../ZPlanning2Row";
import { Planning2TableStore } from "./Planning2TableStore";
import styles from "./Planning2Table.module.less";

type PropsPlanning2Table = {
  data: Planning2ControlData;
};

/**
 * @deprecated новый компонент: Planning2Gantt. Этот оставлен пока новый не дотестирован. Затем его можно удалить.
 */
export const Planning2Table: React.FC<PropsPlanning2Table> = observer(
  ({ data }) => {
    const { tableStore } = data;
    const {
      visibleRows,
      finalColumns: visibleColumns,
      selectedAll,
      loading,
      expandedRowKeys,
    } = tableStore;

    const refTbl = React.useRef<HTMLDivElement>(null);
    const [tblHeight, setTblHeight] = React.useState(100);
    React.useEffect(() => {
      const setHeight = () => {
        const { current } = refTbl;
        if (current) {
          let h = current.clientHeight;
          const thead = current.querySelector("thead");
          if (thead) h -= thead.offsetHeight;
          setTblHeight(h);
        }
      };
      setTimeout(() => setHeight(), 10);
      const onResize = () => {
        setHeight();
      };
      window.addEventListener("resize", onResize);
      return () => {
        window.removeEventListener("resize", onResize);
      };
    }, []);

    const columns = visibleColumns.map((column) => ({
      ...column,
      onHeaderCell: () =>
        ({
          column: { key: String(column.key) } satisfies ColumnPoor,
          ctrlResizable: tableStore.ctrlResizable,
        }) as React.HTMLAttributes<unknown>,
    }));

    return (
      <div ref={refTbl} style={{ height: "100%", overflow: "hidden" }}>
        <Table<ZPlanning2Row>
          rowKey="id"
          className={styles.table}
          columns={columns}
          dataSource={visibleRows}
          loading={loading}
          rowSelection={{
            type: "checkbox",
            renderCell: (_, row) => (
              <RowSelector row={row} store={tableStore} />
            ),
            columnTitle: (
              <Checkbox
                indeterminate={selectedAll === "partial"}
                checked={isChecked(selectedAll)}
                onChange={() => tableStore.toggleAllSelection()}
              />
            ),
          }}
          expandable={{
            expandedRowKeys,
            onExpand: (expanded, record) =>
              tableStore.changeExpand(record.id, expanded),
          }}
          pagination={false}
          scroll={{ y: tblHeight }}
          components={{
            header: {
              cell: CustomHeaderCell,
            },
          }}
        />
      </div>
    );
  },
);

type PropsRowSelector = {
  row: ZPlanning2Row;
  store: Planning2TableStore;
};

const RowSelector: React.FC<PropsRowSelector> = observer(({ row, store }) =>
  row.kind === "task" ? (
    <Checkbox
      checked={store.selectedTasks.has(row.id)}
      onChange={() => store.toggleTaskSelection(row.id)}
    />
  ) : (
    <Checkbox
      checked={isChecked(store.selectedGroups[row.id])}
      indeterminate={store.selectedGroups[row.id] === "partial"}
      onChange={() => store.toggleGroupSelection(row.id)}
    />
  ),
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CustomHeaderCell = (props: any) => {
  const { children, className, column, ctrlResizable, ...rest } = props;
  const cref = React.useRef(null);
  return (
    <th className={classNames([className, styles.th])} {...rest}>
      <div className={styles.headCell}>
        <div className={styles.headLabel}>{children}</div>
        {!!column && !!ctrlResizable && (
          <ResizerStd
            column={column}
            containerRef={cref}
            store={ctrlResizable}
            minWidth={80}
          />
        )}
      </div>
    </th>
  );
};
